import { render, staticRenderFns } from "./registered-deal-widget.vue?vue&type=template&id=607ecc9c&"
import script from "./registered-deal-widget.vue?vue&type=script&lang=js&"
export * from "./registered-deal-widget.vue?vue&type=script&lang=js&"
import style0 from "./registered-deal-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports